@if (!requestedNewLink) {
  <app-new-password formTitle="Reset Password" [userId]="userId" [token]="temporaryToken" [formDisabled]="islandDisabled"
    formSubtitle="You have requested a new password or your password has expired. Please choose a new password. You may NOT use any of your last 5 passwords."
    saveButtonText="Update Password" (isLoading)="loading($event)" (formSubmit)="updatePassword($event)">
    <div class="ng-content-after">
      <br>
      <a routerLink="/forgot-password">Request new password reset token </a>
    </div>
  </app-new-password>
} @else {
  <eca-pillar-box>
    <eca-form-column>
      <h1 class="eca-skip-link-focus-target" tabindex="-1">New Password Reset Request Submitted</h1>
      <p>
        Thank you for submitting your password reset request.
        Please check your email for the next steps to change your password.
      </p>
    </eca-form-column>
  </eca-pillar-box>
}

@if (isLoading$ | async) {
  <div class="spinner-overlay" fxLayout fxLayoutAlign="center center">
    <eca-spinner [diameter]=48 color="primary"></eca-spinner>
  </div>
}
